import { render, staticRenderFns } from "./NutritionIngredient.vue?vue&type=template&id=627cb0c6&scoped=true"
import script from "./NutritionIngredient.vue?vue&type=script&lang=js"
export * from "./NutritionIngredient.vue?vue&type=script&lang=js"
import style0 from "./NutritionIngredient.vue?vue&type=style&index=0&id=627cb0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627cb0c6",
  null
  
)

export default component.exports